import React from "react";

import Card from "../ui/Card";
import Button from "../ui/Button";
import TextInput from "../ui/TextInput";

const DOCUMENT_CATEGORIES = [
  "Sustainability Report",
  "Annual Report",
  "ESG Policy",
  "Code of Conduct",
  "Climate Strategy",
  "Supplier Code",
  "HR Policy",
  "Other"
];

export default function DocumentUploadForm({
  form,
  setForm,
  file,
  setFile,
  uploadStatus,
  onSubmit
}) {
  return (
    <Card>
      <form onSubmit={onSubmit}>
        <TextInput
          label="Company Name"
          value={form.companyName}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              companyName: event.target.value
            }))
          }
          placeholder="Example: Telenet"
          fullWidth
        />

        <label style={labelStyle}>Category</label>
        <select
          value={form.category}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              category: event.target.value
            }))
          }
          style={inputStyle}
        >
          {DOCUMENT_CATEGORIES.map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>

        <TextInput
          label="Reporting Year"
          type="number"
          value={form.reportingYear}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              reportingYear: event.target.value
            }))
          }
          fullWidth
        />

        <TextInput
          label="Tags"
          value={form.tags}
          onChange={(event) =>
            setForm((prev) => ({
              ...prev,
              tags: event.target.value
            }))
          }
          placeholder="CSRD,ESRS,Climate"
          fullWidth
        />

        <label style={labelStyle}>Document</label>
        <input
          type="file"
          accept=".pdf,.docx,.xlsx,.pptx,.csv"
          onChange={(event) => setFile(event.target.files?.[0] || null)}
          style={inputStyle}
        />

        <Button type="submit">
          {file ? "Upload Document" : "Select a Document"}
        </Button>
      </form>

      {uploadStatus && <p>{uploadStatus}</p>}
    </Card>
  );
}

const labelStyle = {
  display: "block",
  fontSize: 14,
  fontWeight: 600,
  marginBottom: 6
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginTop: "6px",
  marginBottom: "14px",
  borderRadius: "8px",
  border: "1px solid #cbd5e1",
  boxSizing: "border-box"
};